import PropTypes from 'prop-types';

function ErrorMessage({ error, size }) {
    if (!error || typeof error !== 'string') {
        return null;
    }

    const errTextSize = () => {
        if (['medium', 'large'].includes(size)) {
            return ' text-sm';
        }
    };

    return <div className={`text-red ${errTextSize()}`}>{error}</div>;
}

ErrorMessage.propTypes = {
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    size: PropTypes.oneOf(['medium', 'large']),
};

export default ErrorMessage;
